import { Logtail } from "@logtail/browser";

// TODO: Replace with your actual Betterstack source token
const BETTERSTACK_SOURCE_TOKEN = process.env.REACT_APP_BETTERSTACK_SOURCE_TOKEN;
const BETTERSTACK_INGEST_URL = "https://s1342339.eu-nbg-2.betterstackdata.com";

let logtail;

if (BETTERSTACK_SOURCE_TOKEN) {
  try {
    logtail = new Logtail(BETTERSTACK_SOURCE_TOKEN, {
      endpoint: BETTERSTACK_INGEST_URL,
      // Send logs in batches every 5 seconds
      batchInterval: 5000, 
      // Don't buffer more than 100 logs in memory
      batchSize: 100, 
    });

    // Add middleware to include user context
    logtail.use(async (log) => {
      const userEmail = localStorage.getItem('user_email');
      return {
        ...log,
        context: {
          ...log.context,
          user: {
            email: userEmail || 'Not available',
          },
        },
      };
    });

    console.log("Betterstack logging initialized.");
  } catch (error) {
    console.error("Failed to initialize Betterstack logging:", error);
  }
} else {
    console.warn("Betterstack source token not found. Logging to console only.");
}

const originalConsole = {
  log: console.log.bind(console),
  info: console.info.bind(console),
  warn: console.warn.bind(console),
  error: console.error.bind(console),
  debug: console.debug.bind(console),
};

function overrideConsole() {
  if (!logtail) {
    return;
  }

  const logMessage = (level, ...args) => {
    // Log to original console
    originalConsole[level](...args);

    // Prepare message for Logtail
    const message = args.map(arg => {
      if (typeof arg === 'object' && arg !== null) {
        try {
          return JSON.stringify(arg);
        } catch (e) {
          return 'Unserializable object';
        }
      }
      return String(arg);
    }).join(' ');

    // Send to Logtail
    if (logtail[level]) {
        logtail[level](message);
    } else {
        logtail.log(message, level);
    }
  };

  console.log = (...args) => logMessage('info', ...args);
  console.info = (...args) => logMessage('info', ...args);
  console.warn = (...args) => logMessage('warn', ...args);
  console.error = (...args) => logMessage('error', ...args);
  console.debug = (...args) => logMessage('debug', ...args);
}

export function initLogging() {
  overrideConsole();
} 